import React from "react";
import "react-datepicker/dist/react-datepicker.css";

import useDocumentTitle from '../../hooks/useDocumentTitle'
import HotelSearchForm from "./HotelSearchForm";

export default function Hotel() {
  useDocumentTitle('Hotel Search');

  return (
    <>
      <div className="bg-gray-100 text-gray-800 relative min-h-screen">
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">
          <HotelSearchForm />
        </main>
      </div>
    </>
  );
}
